import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box } from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import resourceWrapper from 'utils/framework/resourceWrapper';
import { breakpoints } from 'style/config';
import BiFreeShippingEN from 'components/RwdBasket/Messages/BiFreeShipping/locales/BiFreeShipping_en_US';
import BiFreeShippingFR from 'components/RwdBasket/Messages/BiFreeShipping/locales/BiFreeShipping_fr_CA';

const { getLocalisedDataFromResource } = localeUtils;

function isSmallView() {
    return window.matchMedia(breakpoints.smMax).matches;
}

function BiFreeShipping({
    hasMetFreeShippingThreshhold,
    isSignedInBIUser,
    baseColor,
    freeShipColor,
    isFreeShipBold = false,
    potentialBeautyBankPoints,
    showBasketShippingAndPoints,
    ...customBoxStyle
}) {
    const getText = resourceWrapper(getLocalisedDataFromResource(BiFreeShippingEN, BiFreeShippingFR));
    let coloredText = `{color:${freeShipColor}}${getText('biFreeShipVar')}{color}`;
    let altText = null;
    const isSmallUS = localeUtils.isUS() && isSmallView();

    if (isFreeShipBold) {
        coloredText = `*${coloredText}*`;
    }

    if (isSmallUS && showBasketShippingAndPoints && potentialBeautyBankPoints > 0) {
        altText = getText('biFreeShipPointsVar', true, potentialBeautyBankPoints);
    }

    // INFL-2247
    return (
        <Box
            color={baseColor}
            {...customBoxStyle}
        >
            {altText ? altText : getText(isSignedInBIUser || !hasMetFreeShippingThreshhold ? 'biFreeShip' : 'freeShipQualifies', true, coloredText)}
        </Box>
    );
}

export default wrapFunctionalComponent(BiFreeShipping, 'BiFreeShipping');
